import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { mediaQueries } from 'plugins/device'
import { PleaseLogin } from '@blocket/authentication-fe'
import {
  FullHeightWrapper,
  FullWidthWrapper as WidthWrapper,
  ResponsiveColumnWrapper as ColumnWrapper,
} from 'components/sharedComponents/LayoutStyles'
import TabBar from 'components/sharedComponents/TabBar'
import Footer from 'components/sharedComponents/Footer'
import { colors } from '@blocket/blocket-ui'

const FullWidthWrapper = styled(WidthWrapper)`
  flex-grow: 1;
  min-height: auto;
`

const ResponsiveColumnWrapper = styled(ColumnWrapper)`
  flex-grow: 1;
`

const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${colors.white100};
  padding: 0px 22px;
  @media ${mediaQueries.medium} {
    margin: 16px 0px;
  }
`

const LoginPrompt = ({ redirectUri, cancelUri, icon, headline, infoText, buttonText, tag }) => {
  return (
    <FullHeightWrapper>
      <TabBar />
      <FullWidthWrapper>
        <ResponsiveColumnWrapper>
          <Wrapper>
            <PleaseLogin
              redirectUri={redirectUri}
              cancelUri={cancelUri}
              icon={icon}
              headline={headline}
              infoText={infoText}
              buttonText={buttonText}
              tag={tag}
              vendBranding
            />
          </Wrapper>
        </ResponsiveColumnWrapper>
      </FullWidthWrapper>
      <Footer />
    </FullHeightWrapper>
  )
}

LoginPrompt.propTypes = {
  redirectUri: PropTypes.string,
  cancelUri: PropTypes.string,
  icon: PropTypes.object,
  headline: PropTypes.string,
  infoText: PropTypes.string,
  buttonText: PropTypes.string,
  tag: PropTypes.string,
}

export default LoginPrompt
